<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="chat-container full-height">
    <!-- <el-tag v-if="chatDirectInfo && chatDirectInfo.length > 0" type="danger"
      >未讀{{ chatDirectInfo[0].notReadCount }}</el-tag
    > -->
    <!-- 客訴mobile -->
    <el-dialog
      v-if="device == 'mobile' && toUser"
      :title="'聊天訊息'"
      :visible.sync="dialogMessageVisible"
      fullscreen
      v-loading="chatLoading"
      class="messageDialog"
      @closed="obDialogClosed()"
    >
      <el-card
        class="box-card el-card-define chat-window full-height"
        :body-style="{ height: '88%', 'overflow-y': 'scroll' }"
      >
        <div slot="header" class="clearfix">
          <span>{{ toUser.userName }}</span>
        </div>
        <template
          v-if="
            (panel === 'chat' &&
              filtered_list.length > 0 &&
              filtered_list[0].messages &&
              filtered_list[0].messages.length > 0) ||
            (panel === 'groupChat' &&
              filtered_group_list.length > 0 &&
              filtered_group_list[0].messages &&
              filtered_group_list[0].messages.length > 0)
          "
        >
          <div
            v-if="panel === 'chat'"
            v-for="(item, index) in filtered_list[0].messages"
            :key="'chat-' + index"
          >
            <el-row>
              <el-col :span="24">
                <div class="chat-date">
                  <el-tag>{{ item.date }}</el-tag>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                  <div class="chat-container-from" v-if="d.from != fromUser">
                    <div>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-form">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          :preview-src-list="[d.fileInfo.url]"
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                        ></el-image>
                      </span>
                      <i class="time-flag"> {{ d.time }}</i>
                    </div>
                  </div>
                  <div
                    style="text-align: right"
                    class="chat-container-send"
                    v-if="d.from == fromUser"
                  >
                    <div>
                      <i v-if="d.isRead" class="read-flag">已讀</i>
                      <i class="time-flag">{{ d.time }}</i>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-send">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                          :preview-src-list="[d.fileInfo.url]"
                        ></el-image>
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div
            v-if="panel === 'groupChat'"
            v-for="(item, index) in filtered_group_list[0].messages"
            :key="'group-' + index"
          >
            <el-row>
              <el-col :span="24">
                <div class="chat-date">
                  <el-tag>{{ item.date }}</el-tag>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                  <div class="chat-container-from" v-if="d.from != fromUser">
                    <div>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-form">
                        {{ d.from }}：{{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          :preview-src-list="[d.fileInfo.url]"
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                        ></el-image>
                      </span>
                      <span v-if="d.chatType == 4">
                        <div style="margin-bottom: 5px; color: #42443f">{{ d.from }}：</div>
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="d.msg"
                          :fit="'cover'"
                          :preview-src-list="[d.msg]"
                        ></el-image>
                      </span>
                      <i class="time-flag"> {{ d.time }}</i>
                    </div>
                  </div>
                  <div
                    style="text-align: right"
                    class="chat-container-send"
                    v-if="d.from == fromUser"
                  >
                    <div>
                      <i v-if="d.isRead" class="read-flag">已讀</i>
                      <i class="time-flag">{{ d.time }}</i>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-send">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                          :preview-src-list="[d.fileInfo.url]"
                        ></el-image>
                      </span>
                      <span v-if="d.chatType == 4">
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="d.msg"
                          :fit="'cover'"
                          :preview-src-list="[d.msg]"
                        ></el-image>
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-card>
      <el-input
        v-if="panel === 'chat'"
        :disabled="chatLoading"
        style="width: 100%"
        v-model="msg"
        placeholder="請輸入內容"
        @keyup.enter.native="sendMsg"
      >
        <template slot="prepend">
          <Upload
            ref="uploadMobileChatRef"
            :accept="'.img,.jpg,.png,.jpeg,.bmp'"
            :payload="{ from: fromUser, to: toUser ? toUser.userAccount : '' }"
            :data-obj="fileObj"
            :limit-file-count="20"
            :use-drag="false"
            :action="'Chat'"
            :auto-upload="true"
            :show-file-list="false"
            :btn-txt="'上傳'"
            :before-file-list="[]"
            :show-limit="false"
            :sendFileMsgCallback="sendFileMsg"
          />
        </template>
        <template slot="append">
          <el-button
            :disabled="chatLoading"
            icon="el-icon-s-promotion"
            type="success"
            @click="sendMsg"
          />
        </template>
      </el-input>
      <el-input
        v-if="panel === 'groupChat'"
        :disabled="chatLoading"
        style="width: 100%"
        v-model="groupMsg"
        placeholder="請輸入群組訊息"
        @keyup.enter.native="sendMsg"
      >
        <template slot="prepend">
          <Upload
            ref="uploadMobileGroupRef"
            :accept="'.img,.jpg,.png,.jpeg,.bmp'"
            :payload="{ from: fromUser, to: groupToUser ? groupToUser.userID : '' }"
            :data-obj="fileObj"
            :limit-file-count="20"
            :use-drag="false"
            :action="'Chat'"
            :auto-upload="true"
            :show-file-list="false"
            :btn-txt="'上傳'"
            :before-file-list="[]"
            :show-limit="false"
            :sendFileMsgCallback="sendFileMsg"
          />
        </template>
        <template slot="append">
          <el-button
            :disabled="chatLoading"
            icon="el-icon-s-promotion"
            type="success"
            @click="sendMsg"
          />
        </template>
      </el-input>
    </el-dialog>

    <el-tabs v-model="panel" type="border-card" class="full-height">
      <el-tab-pane label="好友列表" name="userList" class="full-height">
        <el-row class="row-box full-height">
          <el-col v-loading="listLoading" :span="6" class="full-height" :xs="24">
            <el-card class="box-card el-card-define full-height" :body-style="{ height: '100%' }">
              <div class="full-height">
                <el-table
                  @row-dblclick="rowDbClick"
                  :data="userList"
                  style="width: 100%"
                  height="100%"
                  size="mini"
                >
                  <el-table-column prop="userAccount" width="50">
                    <a @click="selectedUser(scope.row.userAccount)"
                      ><el-avatar
                        shape="square"
                        size="medium"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                      ></el-avatar
                    ></a>
                  </el-table-column>

                  <el-table-column prop="userName" style="width: 100%">
                    <template slot-scope="scope">
                      <a @click="selectedUser(scope.row.userAccount)">{{
                        formatShowUserName(scope.row.userName)
                      }}</a>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="status" label="狀態"> </el-table-column> -->
                  <!-- <el-table-column>
                    <template slot-scope="scope">
                      <el-button
                        type="success"
                        size="mini"
                        @click="selectedUser(scope.row.userAccount)"
                      >
                        選擇
                      </el-button>
                    </template>
                    >
                  </el-table-column> -->
                </el-table>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="智遊旅程對話" name="chat" class="full-height">
        <el-row class="row-box full-height">
          <!-- <el-col
            v-loading="listLoading || createLoading"
            :sm="13"
            :md="9"
            :lg="9"
            :xl="9"
            class="full-height hidden-xs-only"
          > -->
          <el-col
            class="full-height"
            v-loading="listLoading || createLoading"
            :xs="24"
            :sm="24"
            :md="9"
            :lg="9"
            :xl="9"
          >
            <el-card class="box-card el-card-define full-height" :body-style="{ height: '100%' }">
              <div v-if="chatDirectInfo && chatDirectInfo.length > 0" class="full-height">
                <el-table height="100%" :data="chatDirectInfo" style="width: 100%" size="mini">
                  <el-table-column width="50">
                    <template slot-scope="scope">
                      <el-avatar
                        shape="square"
                        size="large"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                        @click="selectedUser(scope.row.from)"
                        style="cursor: pointer"
                      ></el-avatar>
                    </template>
                  </el-table-column>

                  <el-table-column prop="fromUserName" style="width: 100%">
                    <template slot-scope="scope">
                      <span @click="selectedUser(scope.row.from)" style="cursor: pointer">
                        {{ formatShowUserName(scope.row.fromUserName) }}
                        <el-alert
                          v-if="scope.row.messages && scope.row.messages.msg"
                          :closable="false"
                          :title="cutText(scope.row.messages.msg)"
                          type="info"
                        />
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column width="60">
                    <template slot-scope="scope">
                      <!-- <el-tag v-if="scope.row.notReadCount > 0" type="danger">{{
                        scope.row.notReadCount
                      }}</el-tag> -->
                      <i v-if="scope.row.messages" style="color: #ccc">{{
                        scope.row.messages.time
                      }}</i>
                      <el-tag v-if="scope.row.notReadCount > 0" type="danger">{{
                        scope.row.notReadCount
                      }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-col>

          <el-col
            v-if="device == 'desktop' && toUser !== undefined && toUser.userAccount"
            class="full-height hidden-xs-only"
            v-loading="chatLoading"
            :span="14"
            :offset="1"
            style="position: relative; height: 92%"
          >
            <el-card
              class="box-card el-card-define chat-window full-height"
              :body-style="{ height: '92%', 'overflow-y': 'scroll' }"
            >
              <div slot="header" class="clearfix">
                <span>{{ formatShowUserName(toUser.userName) }}</span>
              </div>
              <template
                v-if="
                  panel === 'chat' &&
                  filtered_list.length > 0 &&
                  filtered_list[0].messages &&
                  filtered_list[0].messages.length > 0
                "
              >
                <div v-for="(item, index) in filtered_list[0].messages" :key="index">
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-date">
                        <el-tag>{{ item.date }}</el-tag>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                        <div class="chat-container-from" v-if="d.from != fromUser">
                          <div>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-form"
                            >
                              {{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <el-image
                                :preview-src-list="[d.fileInfo.url]"
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                              ></el-image>
                            </span>
                            <i class="time-flag"> {{ d.time }}</i>
                          </div>
                        </div>
                        <div
                          style="text-align: right"
                          class="chat-container-send"
                          v-if="d.from == fromUser"
                        >
                          <div>
                            <i v-if="d.isRead" class="read-flag">已讀</i>
                            <i class="time-flag">{{ d.time }}</i>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-send"
                            >
                              {{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                                :preview-src-list="[d.fileInfo.url]"
                              ></el-image>
                            </span>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-card>
            <el-input
              v-if="panel === 'chat'"
              :disabled="chatLoading"
              style="width: 100%"
              v-model="msg"
              placeholder="請輸入內容"
              @keyup.enter.native="sendMsg"
            >
              <!-- <el-button
                :disabled="chatLoading"
                slot="prepend"
                type="success"
                icon="el-icon-plus"
              ></el-button> -->
              <template slot="prepend">
                <Upload
                  ref="uploadDesktopChatRef"
                  :accept="'.img,.jpg,.png,.jpeg,.bmp'"
                  :payload="{ from: fromUser, to: toUser.userAccount }"
                  :data-obj="fileObj"
                  :limit-file-count="20"
                  :use-drag="false"
                  :action="'Chat'"
                  :auto-upload="true"
                  :show-file-list="false"
                  :multiple="false"
                  :btn-txt="'上傳'"
                  :before-file-list="[]"
                  :show-limit="false"
                  :sendFileMsgCallback="sendFileMsg"
                />
              </template>
              <template slot="append">
                <el-button
                  :disabled="chatLoading"
                  icon="el-icon-s-promotion"
                  type="success"
                  @click="sendMsg"
                />
              </template>
            </el-input>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="旅行團群聊" name="groupChat" class="full-height">
        <el-row class="row-box full-height">
          <el-col
            class="full-height"
            v-loading="listLoading || createLoading"
            :xs="24"
            :sm="24"
            :md="9"
            :lg="9"
            :xl="9"
          >
            <el-card class="box-card el-card-define full-height" :body-style="{ height: '100%' }">
              <div v-if="groupChatDirectInfo && groupChatDirectInfo.length > 0" class="full-height">
                <el-table height="100%" :data="groupChatDirectInfo" style="width: 100%" size="mini">
                  <el-table-column width="50">
                    <template slot-scope="scope">
                      <el-avatar
                        shape="square"
                        size="large"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                        @click="selectedGroup(scope.row.from)"
                        style="cursor: pointer"
                      ></el-avatar>
                    </template>
                  </el-table-column>

                  <el-table-column prop="fromUserName" style="width: 100%">
                    <template slot-scope="scope">
                      <span @click="selectedGroup(scope.row.from)" style="cursor: pointer">
                        {{ formatShowUserName(scope.row.fromUserName) }}
                        <el-alert
                          v-if="scope.row.messages && scope.row.messages.msg"
                          :closable="false"
                          :title="cutText(scope.row.messages.msg)"
                          type="info"
                        />
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column width="60">
                    <template slot-scope="scope">
                      <i v-if="scope.row.messages" style="color: #ccc">{{
                        scope.row.messages.time
                      }}</i>
                      <el-tag v-if="scope.row.notReadCount > 0" type="danger">{{
                        scope.row.notReadCount
                      }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-col>

          <el-col
            v-if="
              device == 'desktop' &&
              panel === 'groupChat' &&
              groupToUser !== undefined &&
              groupToUser.userAccount
            "
            class="full-height hidden-xs-only"
            v-loading="chatLoading"
            :span="14"
            :offset="1"
            style="position: relative; height: 92%"
          >
            <el-card
              class="box-card el-card-define chat-window full-height"
              :body-style="{ height: '92%', 'overflow-y': 'scroll' }"
            >
              <div slot="header" class="clearfix">
                <span>{{ formatShowUserName(groupToUser.userName) }}</span>
              </div>
              <template
                v-if="
                  panel === 'groupChat' &&
                  filtered_group_list.length > 0 &&
                  filtered_group_list[0].messages &&
                  filtered_group_list[0].messages.length > 0
                "
              >
                <div v-for="(item, index) in filtered_group_list[0].messages" :key="index">
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-date">
                        <el-tag>{{ item.date }}</el-tag>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                        <div class="chat-container-from" v-if="d.from != fromUser">
                          <div>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-form"
                            >
                              {{ d.from }}：{{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <el-image
                                :preview-src-list="[d.fileInfo.url]"
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                              ></el-image>
                            </span>
                            <span v-if="d.chatType == 4">
                              <div style="margin-bottom: 5px">{{ d.from }}：</div>
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="d.msg"
                                :fit="'cover'"
                                :preview-src-list="[d.msg]"
                              ></el-image>
                            </span>
                            <i class="time-flag"> {{ d.time }}</i>
                          </div>
                        </div>
                        <div
                          style="text-align: right"
                          class="chat-container-send"
                          v-if="d.from == fromUser"
                        >
                          <div>
                            <i v-if="d.isRead" class="read-flag">已讀</i>
                            <i class="time-flag">{{ d.time }}</i>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-send"
                            >
                              {{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                                :preview-src-list="[d.fileInfo.url]"
                              ></el-image>
                            </span>
                            <span v-if="d.chatType == 4">
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="d.msg"
                                :fit="'cover'"
                                :preview-src-list="[d.msg]"
                              ></el-image>
                            </span>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-card>
            <el-input
              v-if="panel === 'groupChat'"
              :disabled="chatLoading"
              style="width: 100%"
              v-model="groupMsg"
              placeholder="請輸入內容"
              @keyup.enter.native="sendMsg"
            >
              <template slot="prepend">
                <Upload
                  ref="uploadDesktopGroupRef"
                  :accept="'.img,.jpg,.png,.jpeg,.bmp'"
                  :payload="{ from: fromUser, to: groupToUser ? groupToUser.userID : '' }"
                  :data-obj="fileObj"
                  :limit-file-count="20"
                  :use-drag="false"
                  :action="'Chat'"
                  :auto-upload="true"
                  :show-file-list="false"
                  :multiple="false"
                  :btn-txt="'上傳'"
                  :before-file-list="[]"
                  :show-limit="false"
                  :sendFileMsgCallback="sendFileMsg"
                />
              </template>
              <template slot="append">
                <el-button
                  :disabled="chatLoading"
                  icon="el-icon-s-promotion"
                  type="success"
                  @click="sendMsg"
                />
              </template>
            </el-input>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'

// import this.$socket from "@/utils/socket";
import { _uuid } from '@/utils/funcs'
import { mapGetters } from 'vuex'
import {
  markMessageAsRead,
  getDirectMessages,
  getAnUser,
  getGroupMessageList,
  getAnGroup,
} from '@/api/chat'
import settings from '@/settings'
export default {
  name: 'ChatComponents',
  components: {
    Upload: () => import('@/views/ita/components/fileUpload.vue'),
  },
  props: {
    userList: {
      type: Array,
      default: () => [],
    },
    fromUser: {
      type: String,
      default: () => '',
    },
  },
  async activated() {},
  async mounted() {
    await this.pageInit()
  },
  data() {
    return {
      fileObj: { id: 0, type: 'chat', user: '' },
      createLoading: false,
      panel: '',
      listLoading: false,
      chatLoading: false,
      chatList: [],
      currentCharMessages: [],
      msg: '',
      toUser: {},
      msgkey: '',
      chatDirectInfo: [],
      dialogMessageVisible: false,

      // 旅行團群聊
      groupChatDirectInfo: [],
      groupMsg: '',
      groupToUser: {},
      groupChatList: [],
      currentGroupCharMessages: [],
    }
  },
  computed: {
    ...mapGetters(['device']),
    filtered_list() {
      if (this.chatList && this.chatList.length > 0) {
        this.currentCharMessages = this.chatList[0].messages
        return this.chatList
      }
      // 返回一個有正確結構的預設值，避免模板中的 undefined 錯誤
      return [
        {
          messages: [],
        },
      ]
    },
    filtered_group_list() {
      if (
        this.groupChatList &&
        this.groupChatList.length > 0 &&
        this.groupChatList[0] &&
        this.groupChatList[0].messages
      ) {
        this.currentGroupCharMessages = this.groupChatList[0].messages
        return this.groupChatList
      }
      // 返回一個有正確結構的預設值，避免模板中的 undefined 錯誤
      return [
        {
          messages: [],
        },
      ]
    },
  },
  watch: {
    userList: {
      handler: function (newVal, oldVal) {
        const vm = this
        if (newVal.length > 0) {
          this.listLoading = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    // this.getDirectMessages ()
    // 註冊ws 監聽事件，當後端異動觸發 handleGetMessage方法
    this.$socket.$on('open', this.handleConnected)
    this.$socket.$on('message', this.handleGetMessage)
    this.$socketGroup.$on('open', this.handleConnectedGroup)
    this.$socketGroup.$on('message', this.handleGetGroupMessage)
    await this.pageInit()
    await this.pageInitGroupChat()
  },
  methods: {
    formatShowUserName(name) {
      return name === '智遊旅程行政人員' ? '智遊旅程客服人員' : name
    },
    async getAnUser(userAccount) {
      let resp = await getAnUser({ userAccount })
      return resp.data
    },
    async getAnGroup(userAccount) {
      let resp = await getAnGroup({ userAccount })
      return resp.data
    },
    async pageInit() {
      this.panel = 'chat'
      this.createLoading = true
      await this.getDirectMessages()
      this.createLoading = false
    },
    async pageInitGroupChat() {
      this.panel = 'groupChat'
      this.createLoading = true
      await this.getGroupMessageList()
      this.createLoading = false
    },
    chatRowDbClick(row, column, event) {
      this.selectedUser(row.from)
    },
    rowDbClick(row, column, event) {
      this.selectedUser(row.userAccount)
    },
    handleConnected() {
      this.getDirectMessages()
      this.panel = 'chat'
    },
    handleConnectedGroup() {
      this.getGroupMessageList()
      this.panel = 'groupChat'

      // 如果已經選擇了群組，重新註冊群組
      if (this.groupToUser && this.groupToUser.userID) {
        const groupId = `GroupChat_${this.groupToUser.userID}`
        const registerGroupMsg = {
          type: 20, // 群組註冊類型
          from: this.fromUser,
          to: [groupId],
          action: 'joinGroup',
          groupId: groupId,
          msg: `${this.fromUser} rejoined group ${groupId}`,
        }
        // console.log('重新註冊群組訊息:', registerGroupMsg)
        this.$socketGroup.send(registerGroupMsg)
      }
    },
    async getDirectMessages() {
      const vm = this
      let res = await getDirectMessages({ account: vm.fromUser })
      vm.chatDirectInfo = res.data || []

      if (vm.chatDirectInfo.length > 0) {
        let msgCountSum = vm.chatDirectInfo
          .map(item => item.notReadCount || 0)
          .reduce((prev, next) => prev + next)
        this.$store.dispatch('app/setMessage', parseInt(msgCountSum))
      } else {
        this.panel = 'userList'
      }
    },
    async getGroupMessageList() {
      const vm = this
      let res = await getGroupMessageList({ account: vm.fromUser })
      vm.groupChatDirectInfo = res.data || []

      if (vm.groupChatDirectInfo.length > 0) {
        let msgCountSum = vm.groupChatDirectInfo
          .map(item => item.notReadCount || 0)
          .reduce((prev, next) => prev + next)
        this.$store.dispatch('app/setMessage', parseInt(msgCountSum))
      } else {
        this.$store.dispatch('app/setMessage', 0)
      }
    },
    async selectedUser(user) {
      const vm = this
      vm.toUser = vm.userList.filter(f => {
        return f.userAccount == user
      })[0]
      if (!vm.toUser) {
        let findUser = await vm.getAnUser(user)
        vm.toUser = findUser
      }

      if (vm.panel != 'chat') {
        vm.panel = 'chat'
      }

      if (this.device == 'mobile') {
        this.dialogMessageVisible = true
      }

      vm.chatLoading = true

      // 建立聊天室並標示訊息已讀
      const payload = { from: user, to: [vm.fromUser] }
      markMessageAsRead(payload).then(async response => {
        await this.getDirectMessages()
        //response.data 為完整對話紀錄
        vm.chatList = response.data
        vm.chatLoading = false
        // 聊天視窗向底部
        setTimeout(() => {
          vm.updateScrollTop()
        }, 500)
      })
    },
    async selectedGroup(user) {
      const vm = this
      vm.groupToUser = vm.userList.filter(f => {
        return f.userAccount == user
      })[0]
      if (!vm.groupToUser) {
        let findUser = await vm.getAnGroup(user)
        vm.groupToUser = findUser
      }

      if (vm.panel != 'groupChat') {
        vm.panel = 'groupChat'
      }

      if (this.device == 'mobile') {
        this.dialogMessageVisible = true
      }

      vm.chatLoading = true

      // 建立聊天室並標示訊息已讀
      // console.log('selectedGroup user', user)
      // console.log('selectedGroup fromUser', vm.fromUser)
      // 確保群組 ID 格式一致
      const groupId = `GroupChat_${vm.groupToUser.userID}`
      const payload = { from: vm.fromUser, to: [groupId], isFromAppClient: false }
      // console.log('群組註冊 payload:', payload)
      markMessageAsRead(payload).then(async response => {
        await this.getGroupMessageList()
        // response.data 為完整群聊對話紀錄
        vm.groupChatList = response.data // <--- 塞到 groupChatList
        // console.log('Group chat list loaded:', vm.groupChatList)

        // 確保至少有一個空的訊息日期結構
        if (vm.groupChatList.length > 0 && vm.groupChatList[0].messages.length === 0) {
          const today = new Date().toISOString().split('T')[0]
          vm.groupChatList[0].messages.push({
            date: today,
            charMsgInfos: [],
          })
          // console.log('Created empty message structure for today')
        }

        vm.chatLoading = false

        // 向 WebSocket 伺服器註冊當前群組
        const registerGroupMsg = {
          type: 20, // 群組註冊類型
          from: vm.fromUser,
          to: [groupId],
          action: 'joinGroup',
          groupId: groupId,
          msg: `${vm.fromUser} joined group ${groupId}`,
        }
        // console.log('註冊群組訊息:', registerGroupMsg)
        vm.$socketGroup.send(registerGroupMsg)

        // 聊天視窗向底部
        setTimeout(() => {
          vm.updateScrollTop()
        }, 500)
      })
    },
    obDialogClosed() {
      this.chatList = []
      this.toUser = {}
      this.currentCharMessages = []

      this.groupChatList = []
      this.groupToUser = {}
      this.currentGroupCharMessages = []
    },
    sendMsg() {
      const vm = this
      // console.log('發送訊息', this.msg, this.panel, this.toUser)
      if (this.panel === 'chat') {
        if (!this.msg.trim()) {
          return
        }
        this.msgkey = _uuid()
        const newMsg = {
          chatType: 1,
          from: this.fromUser,
          guid: this.msgkey,
          isRead: false,
          msg: this.msg,
          time: '',
          to: [this.toUser.userAccount],
          type: 1,
        }
        vm.appendMegToView(newMsg, 'chat')
        this.updateScrollTop()
        this.$socket.send(newMsg)
        vm.msg = ''
      } else if (this.panel === 'groupChat') {
        if (!this.groupMsg.trim()) return
        // console.log('發送群組訊息this.groupToUser', this.groupToUser)
        // console.log('發送群組訊息this.fromUser', this.fromUser)
        this.msgkey = _uuid()
        const newMsg = {
          chatType: 1,
          from: this.fromUser,
          guid: this.msgkey,
          isRead: false,
          msg: this.groupMsg,
          time: '',
          to: ['GroupChat_' + this.groupToUser.userID],
          type: 1,
        }
        // console.log('發送群組文字訊息:', newMsg)
        this.appendMegToView(newMsg, 'group')
        this.$socketGroup.send(newMsg)
        vm.groupMsg = ''
      }
    },
    sendFileMsg(file) {
      const vm = this

      if (this.panel === 'chat') {
        // 要判斷已讀，要知道對方是不是正在我的聊天視窗
        this.msgkey = _uuid()
        const newMsg = {
          chatType: 2, // 聊天內容類型 1文字 2圖片 3檔案
          from: this.fromUser, // 發送方
          guid: this.msgkey, // guid訊息識別碼
          isRead: false, // 是否已讀
          msg: '', // 聊天內容文字
          time: '', // 聊天時間
          to: [this.toUser.userAccount], // 傳送對像
          type: 1, // 傳送類型 1聊天 2通知..
          fileInfo: file,
        }

        // 添加至畫面
        vm.appendMegToView(newMsg, 'chat')

        // 聊天視窗向底部
        this.updateScrollTop()
        this.$socket.send(newMsg)
        vm.msg = ''
      } else if (this.panel === 'groupChat') {
        // 要判斷已讀，要知道對方是不是正在我的聊天視窗
        this.msgkey = _uuid()
        const newMsg = {
          chatType: 2, // 聊天內容類型 1文字 2圖片 3檔案
          from: this.fromUser, // 發送方
          guid: this.msgkey, // guid訊息識別碼
          isRead: false, // 是否已讀
          msg: '', // 聊天內容文字
          time: '', // 聊天時間
          to: ['GroupChat_' + this.groupToUser.userID], // 傳送對像，與文字訊息保持一致
          type: 1, // 傳送類型 1聊天 2通知..
          fileInfo: file,
        }

        // 如果檔案沒有 URL，可能是 base64 格式，先嘗試使用 base64 作為臨時顯示
        if (file && !file.url && file.base64) {
          newMsg.fileInfo = {
            ...file,
            url: `data:image/png;base64,${file.base64}`,
          }
        }

        this.appendMegToView(newMsg, 'group')
        this.$socketGroup.send(newMsg)
        vm.groupMsg = ''
      }
    },
    async handleGetMessage(msg) {
      const vm = this
      const res = JSON.parse(msg.data)

      // console.log("收到訊息");
      switch (res.type) {
        case 1:
          vm.markMessageAsTime(res.guid, res.time, res.fileInfo)
          break
        case 2: // 通知
          break
        case 3: // 聊天已接收確認 callback 收到訊息方type=4要回callback
          // 代表傳送方和目前開啟的聊天室窗是同一個帳號 可以回覆已讀
          const req = res
          if (res.from == vm.toUser.userAccount) {
            // 添加至畫面
            req.type = 4
            req.from = this.fromUser
            req.to = [this.toUser.userAccount]
            const append = JSON.parse(JSON.stringify(req))
            append.from = req.to[0]
            append.to = [req.from]
            vm.appendMegToView(append, 'chat')
            // alert("畫面focUs可以添加訊息");
            // alert("我收到訊息了，告知對方可以已讀了");
          } else {
            // alert("有人傳給我 但我沒有看 跟對方說沒有正在看");
            // 不在目前對話視窗 重新取得取得聊天通知筆數(簡易資料)
            req.type = 5
            // let f = res.to[0];
            // req.to = [res.from];
            // req.from = f;
            //debugger;
          }
          this.$socket.send(req)
          break
        case 4: // 已讀
          // alert("對方打開我跟我的對話框，所以可以改為已讀");
          // 標示已讀
          //可以用guid去找出那一條訊息標是已讀，這邊是把所有跟對方對話的訊息中 未讀的都改已讀
          vm.markMessageAsRead()
          break
        case 5: // 對方未即時接收
          // alert("對方未即時接收");
          break
        case 20:
          break
        case 21: // 取得聊天通知筆數(簡易資料)
          break
        case 500: // 錯誤訊息
          this.$message({
            message: res.msg,
            type: 'danger',
          })
          break
        default:
          break
      }

      await vm.getDirectMessages()
    },
    async handleGetGroupMessage(msg) {
      // console.log('=== 收到群組訊息 ===', msg)
      const vm = this
      const res = JSON.parse(msg.data)
      // console.log('群組訊息內容:', res)
      // console.log('當前用戶:', vm.fromUser)
      // console.log('當前選擇的群組:', vm.groupToUser)

      switch (res.type) {
        case 1:
          vm.markMessageAsTime(res.guid, res.time, res.fileInfo)
          break
        case 2: // 通知
          break
        case 3: // 聊天已接收確認 callback 收到訊息方type=4要回callback
          // 檢查是否是發送給目前開啟的群組聊天室
          // console.log('檢查群組訊息目標:', res.to)
          // console.log('當前群組用戶:', vm.groupToUser)

          const currentGroupId = `GroupChat_${vm.groupToUser?.userID}`
          const isCurrentGroupChat =
            res.to &&
            res.to.some(
              to =>
                to === currentGroupId ||
                to === vm.groupToUser?.userID ||
                (to.includes('GroupChat_') && to.includes(vm.groupToUser?.userID))
            )

          // console.log('是否為當前群組訊息:', isCurrentGroupChat)

          if (isCurrentGroupChat && res.from !== vm.fromUser) {
            // 這是其他人發送給目前群組的訊息，需要添加到畫面
            // console.log('Adding group message from:', res.from)
            vm.appendMegToView(res, 'group')

            // 回覆確認收到訊息
            const confirmMsg = {
              ...res,
              type: 4,
              from: vm.fromUser,
              to: [res.from],
            }
            vm.$socketGroup.send(confirmMsg)
          } else if (res.from === vm.fromUser) {
            // 這是自己發送的訊息，不需要額外處理
            // console.log('Own message, skip adding to view')
          } else {
            // 不是目前群組的訊息，回覆未即時接收
            const req = { ...res, type: 5 }
            vm.$socketGroup.send(req)
          }
          break
        case 4: // 已讀
          // 標示已讀
          vm.markMessageAsRead()
          break
        case 5: // 對方未即時接收
          // console.log('對方未即時接收群組訊息')
          break
        case 20: // 群組註冊相關
          // console.log('群組註冊訊息:', res)
          if (res.action === 'joinGroup') {
            // console.log('用戶加入群組:', res.from, '群組:', res.groupId)
          }
          break
        case 21: // 取得聊天通知筆數(簡易資料)
          break
        case 500: // 錯誤訊息
          this.$message({
            message: res.msg,
            type: 'danger',
          })
          break
        default:
          break
      }

      await vm.getGroupMessageList()
    },
    appendMegToView(newMsg, type) {
      const vm = this

      if (type === 'chat') {
        if (vm.currentCharMessages.length > 0) {
          const currentChat = vm.currentCharMessages[vm.currentCharMessages.length - 1]
          if (!currentChat.charMsgInfos) currentChat.charMsgInfos = []
          currentChat.charMsgInfos.push(newMsg)
        } else {
          alert('未取得聊天紀錄')
        }
      } else if (type === 'group') {
        if (vm.groupChatList.length > 0) {
          if (vm.groupChatList[0].messages.length > 0) {
            const currentGroup =
              vm.groupChatList[0].messages[vm.groupChatList[0].messages.length - 1]
            if (!currentGroup.charMsgInfos) {
              vm.$set(currentGroup, 'charMsgInfos', [])
            }

            // 使用 Vue.set 來確保響應式更新
            const newCharMsgInfos = [...currentGroup.charMsgInfos, newMsg]
            vm.$set(currentGroup, 'charMsgInfos', newCharMsgInfos)

            // 強制觸發整個 groupChatList 的更新
            vm.$set(vm.groupChatList, 0, { ...vm.groupChatList[0] })

            // 使用 nextTick 確保 DOM 更新完成後再滾動
            vm.$nextTick(() => {
              vm.updateScrollTop()
            })
          } else {
            alert('群組聊天沒有訊息紀錄')
          }
        } else {
          alert('未取得群組聊天紀錄')
        }
      }

      if (type === 'chat') {
        vm.updateScrollTop()
      }
    },
    markMessageAsTime(guid, time, fileInfo) {
      const vm = this

      // 處理個人聊天
      if (vm.currentCharMessages.length > 0) {
        vm.currentCharMessages.forEach(m => {
          m.charMsgInfos.forEach(info => {
            if (info.guid == guid) {
              info.time = time
              if (fileInfo) info.fileInfo = fileInfo
            }
          })
        })
      }

      // 處理群組聊天 - 直接操作 groupChatList
      if (vm.groupChatList.length > 0 && vm.groupChatList[0].messages.length > 0) {
        vm.groupChatList[0].messages.forEach(m => {
          if (m.charMsgInfos) {
            m.charMsgInfos.forEach(info => {
              if (info.guid == guid) {
                info.time = time
                if (fileInfo) info.fileInfo = fileInfo
                // 強制觸發更新
                vm.$forceUpdate()
              }
            })
          }
        })
      }
    },
    markMessageAsRead() {
      const vm = this
      // 處理個人聊天已讀狀態
      if (vm.currentCharMessages.length > 0) {
        vm.currentCharMessages.forEach(m => {
          m.charMsgInfos.forEach(info => {
            if (info.isRead == false) {
              info.isRead = true
            }
          })
        })
      }

      // 處理群組聊天已讀狀態 - 直接操作 groupChatList
      if (vm.groupChatList.length > 0 && vm.groupChatList[0].messages.length > 0) {
        vm.groupChatList[0].messages.forEach(m => {
          if (m.charMsgInfos) {
            m.charMsgInfos.forEach(info => {
              if (info.isRead == false) {
                info.isRead = true
              }
            })
          }
        })
      }
    },
    updateScrollTop() {
      // 使用setTimeout確保DOM已更新
      setTimeout(() => {
        const chatWindows = document.getElementsByClassName('chat-window')
        if (chatWindows.length > 0) {
          // 找到目前顯示的聊天視窗
          for (let i = 0; i < chatWindows.length; i++) {
            const chatBody = chatWindows[i].querySelector('.el-card__body')
            if (chatBody && chatBody.offsetParent !== null) {
              // 檢查元素是否可見
              chatBody.scrollTop = chatBody.scrollHeight
            }
          }
        }
      }, 100)
    },
    cutText(s) {
      return s.length > 15 ? s.substring(0, 12) + '...' : s
    },
  },
}
</script>

<style>
.messageDialog .el-dialog__body {
  height: 80% !important;
}

.full-height {
  position: relative;
  height: 100%;
}

.chat-container-from {
  position: relative;
  margin-bottom: 10px;
  /* height: 30px; */
}

.chat-content-form {
  font-size: 15px;
  display: inline-block;
  max-width: 80%;
  position: relative;
  /* background-color: #13ce66; */
  color: white;
  background-color: #fff8e0;
  color: #42443f;
  padding: 4px 8px;
  letter-spacing: 0.05em;
  line-height: 20px;
  width: auto;
  border-radius: 6px;
}

.chat-container-send {
  position: relative;
  margin-bottom: 10px;
  /* height: 30px; */
}

.chat-content-send {
  font-size: 15px;
  display: inline-block;
  max-width: 80%;
  position: relative;
  /* height: 30px; */
  margin-bottom: 3px;
  /* background-color: #ff4949; */
  /* color: white; */
  background-color: #f7f7f7;
  color: #42443f;
  padding: 4px 8px;
  letter-spacing: 0.05em;
  line-height: 20px;
  width: auto;
  border-radius: 6px;
  word-wrap: break-word;
  word-break: normal;
}

.chat-container-from .time-flag {
  bottom: 0px;
  position: absolute;
  font-size: 12px;
  color: #42443f;
  margin-left: 5px;
}

.chat-container-send .time-flag {
  top: 10px;
  font-size: 12px;
  color: #42443f;
  margin-right: 5px;
}

.el-card-define {
  position: relative;
  min-height: 100%;
  height: 100%;
}

.el-card-define >>> .el-card__body {
  position: relative;
  height: 100%;
}

.row-box {
  position: relative;
  height: 100% !important;
}

.el-input-group__append button.el-button {
  background: #42d885;
  border-color: #42d885;
  color: #ffffff;
}

.chat-date {
  text-align: center;
  margin-bottom: 8px;
}

.read-flag {
  font-size: 5px;
  margin-right: 2px;
}

.el-tabs__content {
  position: relative;
  height: 95%;
}
</style>

<style scoped></style>
